const loanStructure = [
  {
    id: 0,
    title: "Interest Only",
    value: "interest only",
  },
  {
    id: 1,
    title: "Interest + Principal",
    value: "interest + principal",
  },
];

const paymentFrequencyList = [
  {
    id: 0,
    title: "Monthly",
    value: "monthly",
  },
  {
    id: 1,
    title: "Bi-Weekly",
    value: "bi-weekly",
  },
  {
    id: 2,
    title: "Semi-Annually",
    value: "semi-annually",
  },
  {
    id: 3,
    title: "Annually",
    value: "annually",
  },
];

const interestRate = [
  {
    id: 0,
    title: "Fixed",
    value: "fixed",
  },
  {
    id: 1,
    title: "Variable",
    value: "variable",
  },
];

const mortgageFeeList = [
  {
    id: 0,
    title: "Flat Fee",
    value: "Flat Fee",
  },
  {
    id: 1,
    title: "% Of Loan Amount",
    value: "% Of Loan Amount",
  },
];

const organizationTypeList = [
  {
    id: 0,
    title: "Limited Partnership Entity",
    value: "Limited Partnership Entity",
  },
  {
    id: 1,
    title: "Limited Partnership",
    value: "Limited Partnership",
  },
  {
    id: 2,
    title: "Sole Proprietorship",
    value: "Sole Proprietorship",
  },
];
const corporationTypeList = [
  {
    id: 0,
    title: "Corporation",
    value: "corporation",
  },
  {
    id: 1,
    title: "Limited Partnership",
    value: "limited partnership",
  },
  {
    id: 2,
    title: "Limited Liability Partnership",
    value: "limited liability partnership",
  },
  {
    id: 3,
    title: "General Partnership",
    value: "general partnership",
  },
  {
    id: 4,
    title: "Joint Venture",
    value: "joint venture",
  },
  {
    id: 5,
    title: "Sole Proprietorship",
    value: "sole proprietorship",
  },
];

export const loanDetailsData = {
  loanStructure,
  paymentFrequencyList,
  interestRate,
  mortgageFeeList,
  corporationTypeList,
  organizationTypeList,
};

export const periodList = [
  { id: 1, title: "Months", value: "month" },
  { id: 2, title: "Years", value: "year" },
];
